export default "__VITE_ASSET__DxMX9zoM__"